module.exports = __webpack_public_path__ + "dingbeauty-landing/img/icon_03.20cb8563.svg";